var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-dialog', _vm._b({ directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }, { name: "dom-active", rawName: "v-dom-active" }], ref: "drag-manager-dialog", staticClass: "drag-manager-dialog", attrs: { "visible": _vm.dialogVisible }, on: { "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      } } }, 'el-dialog', _vm.dialogConfig, false), [_c('div', { staticClass: "drag-manager-dialog-header", attrs: { "slot": "title" }, slot: "title" }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('div', { staticClass: "drag-manager-dialog-body" }, [_vm._t("default")], 2)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };